module.exports = __webpack_public_path__ + "static/media/chevron-up-orange.5f619c29.svg";